// extracted by mini-css-extract-plugin
module.exports = {"container":"Freezed_container__aqHTZ","title":"Freezed_title__Jw_Zs","description":"Freezed_description__B_hkX","content":"Freezed_content__BtZlE"};